module.exports = __webpack_public_path__ + "img/service1.45987b79.png";